<template>
    <div>
        <h1>list the playlists</h1>
    </div>
</template>

<script>
    export default {
        name: "playlists"
    }
</script>

<style scoped>

</style>